import { Box, List, ListItem, ListItemIcon, ListItemText, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { Square } from "@mui/icons-material";
import { ITagTypeMap } from "../../../services/data-file-import-data-service/Models";
import { useTranslation } from "react-i18next";
import { getObjectTypeName } from "../../../common/utilities/GetObjectTypeName";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import { SetPointEventTypeEnum } from "../../../common/enums/SetPointEventTypeEnum";

export type DataFileImportTagsCardProps = {
    items: ITagTypeMap[],
    sx?: SxProps<Theme>; 
};

export function DataFileImportTagsCard({
    items,
    sx
}: DataFileImportTagsCardProps) {

    const { t } = useTranslation();

    const theme = useTheme();

    const objectList = items.sort((a, b) => (a.importColumn.name ?? '').localeCompare(b.importColumn.name ?? ''));

    
    function renderItem(item: ITagTypeMap) {
        return (


            <Typography variant='body2'>
                {t('dataFileImport.tagMapItem', {
                    column: item.importColumn.name,
                    name: item.mappedTagType.name,
                    eventType: SetPointEventTypeEnum[item.eventType ?? SetPointEventTypeEnum.Imported]
                })}
            </Typography>
        )
    }

    return (
        <Box sx={{
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 6,
            marginRight: 1,
            padding: 1,
            paddingBottom: 0,
            ...sx
        }}>
            <Typography variant="body2"
                sx={{
                    color: theme.palette.grey[600],
                }}>
                {getObjectTypeName(eLynxObjectTypeEnum.Tag, true)}
            </Typography>
            <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'        
                    }}>

                        {objectList.map((o, index) =>


                        <ListItem key={index} disablePadding >

                        <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                            <Square fontSize="inherit"/>
                        </ListItemIcon>

                        <ListItemText 
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            primary={
                                // renderProperty('Identifier:', o.identifier)
                                renderItem(o)
                            } 

                            slotProps={{
                                primary: {
                                    component: 'div',
                                    sx: {
                                        fontSize: '.9rem',
                                        display: 'flex',
                                        color: theme.palette.grey[600]
                                    }
                                }
                            }}
                        />

                        </ListItem>  


                        )}                                      
                    </List>
        </Box>
    );
}
